import Button from '@cobliteam/colib-ui/Button';
import Typography from '@cobliteam/colib-ui/Typography';
import { Location } from '@cobliteam/common-types';
import { Link } from 'react-router-dom';

import PlaceholderNoAccess from '../../assets/images/placeholder_no_access.svg?react';

interface AccessDeniedPanelProps {
  pageDescription?: string;
}

const openPermissionsHelpPage = () => {
  const a = document.createElement('a');
  a.href = 'https://manual.cobli.co/docs/comece-por-aqui/nova-conta/quais-permissoes-cada-funcao-tem-acesso';
  a.target = '_blank';
  a.click();
};

const AccessDenied = ({ pageDescription = '' }: AccessDeniedPanelProps) => {
  return (
    <div data-testid='access-denied-panel' className='flex h-full w-full flex-col items-center justify-center gap-5'>
      <div className='flex justify-center'>
        <PlaceholderNoAccess />
      </div>
      <Typography variant='headline' className='gap-1 break-words text-foreground' render={(props) => <h1 {...props} />}>
        Ops... Parece que você está sem acesso.
      </Typography>
      <div className='flex flex-col items-center justify-center gap-2'>
        {pageDescription && (
          <Typography variant='body' className='gap-1 break-words text-foreground'>
            Você está sem permissão para {pageDescription}.
          </Typography>
        )}
        <Typography variant='body' className='gap-1 break-words text-foreground'>
          Fale com o administrador da sua frota para conseguir acesso.
        </Typography>
      </div>
      <Link to={Location.HOME}>
        <Button>Voltar para o início</Button>
      </Link>
      <Button variant='link' onClick={openPermissionsHelpPage}>
        Saiba mais sobre permissões
      </Button>
    </div>
  );
};

export default AccessDenied;
